import { useCallback, useState } from "react";
import { insertResource } from "../../services/communityService";
import { FileProcessModel } from "./models/FileProcessModel";
import { CommunityMediaEnum } from "../../pages/community/enums/CommunityMediaEnum";


const getMediaType = (file: File): CommunityMediaEnum => {

    const extension = file.name.split('.').pop()?.toLowerCase();

    switch (extension) {

        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
        case 'webp':
        case 'svg':
            return CommunityMediaEnum.image;

        case 'mp4':
        case 'webm':
        case 'mov':
        case 'avi':
        case 'mkv':
            return CommunityMediaEnum.video;

        case 'mp3':
        case 'wav':
        case 'ogg':
        case 'aac':
        case 'flac':
            return CommunityMediaEnum.audio;

        case 'pdf':
            return CommunityMediaEnum.document;

        default:
            return CommunityMediaEnum.link;
    }
};

export const useResourceUpload = (forum_id?: number | string) => {
    const [files, setFiles] = useState<FileProcessModel[]>([]);


    const processFiles = useCallback(async (commentId: number) => {
        if(!forum_id)
            return;
        const pendingFiles = files.filter(
            x => x.resourceId === null && !x.isUploading
        );
        for (const pending of pendingFiles) {

            setFiles(prev =>
                prev.map(x =>
                    x.file === pending.file
                        ? { ...x, isUploading: true }
                        : x
                )
            );

            try {

                await insertResource(commentId, pending.file, pending.file.name, getMediaType(pending.file));
                setFiles([]);
            }
            catch { }
            finally { }
        }
    }, [files]);

    const insertFile = (file: File) => {
        setFiles(prev => [...prev, { file, resourceId: null, isUploading: false }]);
    }

    const removeFile = (file: File) => {
        setFiles(prev =>
            prev.filter(x => x.file !== file)
        );
    };


    return {
        files,
        insertFile,
        removeFile,
        processFiles
    };
}